import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {CardCompanyAboutUs} from '../../components/Cards/Company/AboutUs';
import {CardCompanyInfo} from '../../components/Cards/Company/Info';
import {Cookies} from "react-cookie-consent";
import {openDialog} from '../../slices/dialog';
import {selectUser} from '../../slices/profile';
import {CompanyProfileTutorial} from '../../components/Dialog/Company/ProfileTutorial';

export const CompanyProfile = () => {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();

    useEffect(() => {
        const tutorialDone = Cookies.get("profileTutorialDone");
        if (!tutorialDone)
            dispatch(openDialog({
                Content: CompanyProfileTutorial,
                props: {},
                closable: false,
                narrow: true
            }));
    }, [])

    return (
        <>
            <div className="companyProfile">
                <CardCompanyInfo company={user} editable={true}/>
                <CardCompanyAboutUs company={user} editable={true}/>
            </div>
        </>
    );
};